/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Col_Vendor_CodeInputs */

const en_po_col_vendor_code = /** @type {(inputs: Po_Col_Vendor_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendor code`)
};

/**
* | output |
* | --- |
* | "Vendor code" |
*
* @param {Po_Col_Vendor_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_col_vendor_code = /** @type {((inputs?: Po_Col_Vendor_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Col_Vendor_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_col_vendor_code(inputs)
});